<template>
    <div class="support" v-on-clickaway="away">
        <div class="support__icon" :class="{ 'support__icon--active': click }" @click="displayForm">
            <i class="fa fa-question-circle-o" aria-hidden="true"></i>
        </div>

        <div class="support__form">
            <div class="support__header">
                <span class="support__title">Soporte</span>
                <div class="support__controls">
                    <button type="button" class="close" @click="displayForm"><span>&times;</span></button>
                </div>
            </div>
            <input type="text" v-model="form.asunto" class="support__field subject" placeholder="Asunto">
            <textarea v-model="form.mensaje" name="message" class="support__field message" placeholder="Mensaje"></textarea>
            <button @click="guardarSoporte" type="button" class="btn-secondary support__sendbutton">Enviar</button>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [ clickaway ],
    data () {
        return {
            click: false,
            form : {
                asunto : '',
                mensaje : '',
                url : window.location.href 
            },
            url : url,
            errores : {
                asunto : undefined,
                mensaje : undefined
            }
        }
    },
    methods: {
        displayForm () {
            this.click = !this.click
        },
        away () {
            if (this.click) {
                this.click = false;
            }
        },
        limpiarErrores : function () {
            this.errores.asunto = undefined;
            this.errores.mensaje = undefined;
        },
        limpiar : function () {
            this.form.asunto = '';
            this.limpiarErrores();
            this.form.mensaje = '';
        },
        guardarSoporte : function () {
            let that = this;
            this.limpiarErrores();
            axios.post(this.url + '/soporte', this.form).then(function (response) {
                swal('El mensaje ha sido enviado exitósamente. Pronto nos pondremos en contacto con usted.', 'Realizado', 'success');
                that.limpiar();
                that.away();
            }).then(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        if (response.status === 422)
                        {
                            that.errores = response.data.errors;
                            swal('El formulario tiene errores.', 'Error', 'warning');
                        }
                        else 
                            swal('Hubo un error al momento de enviar la información.', 'Error', 'error');
                    }
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/Support.vue